import { ICarDetails } from '../../../../common/model/ICarDetails';
import urlService from '../../common/service/urlService';

export const carsApi = {
  submitCarConfigToForm(carConfiguration: ICarDetails, submissionURL: string): void {
    const form: HTMLFormElement = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('enctype', 'x-www-form-urlencoded');
    form.setAttribute('action', urlService.relativeToAbsolutePath(submissionURL));
    form.setAttribute('style', 'display: none');

    const formInput: any = document.createElement('input');
    formInput.setAttribute('name', 'configuratorJson');
    formInput.setAttribute('type', 'text');

    formInput.setAttribute('value', JSON.stringify(carConfiguration));

    form.appendChild(formInput);
    document.body.appendChild(form);
    form.submit();
  },
};
